import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";

const PageWrapper = styled.div`
    background-color: ${ (props) => props.theme.pageColor};
    min-height: 100vh;
`
const CustomButton = styled(Button)`
    background-color: ${props=>props.theme.hoverSecandary};
    min-width: 150px;
    color: ${props=>props.theme.textPrimary};
    font-weight: 700;

    &:hover{
        background-color: ${props=>props.theme.hoverPrimary};
    }
    &.primary{
        background-color: ${props=>props.theme.hoverPrimary};
        margin-right: 15px;
        &:hover{
            background-color: ${props=>props.theme.hoverSecandary};
        }
    }
`

const SectionHeading = styled(Typography)`
    color: ${props=>props.color? props.color: props.theme.hoverPrimary};
    font-family: 'RifficFree';
    text-align: ${props=>props.align? props.align:'center'};
    text-transform: capitalize;
    padding-bottom: ${props=>props.p? props.p : '40px'};
    font-size: 80px;
    @media(max-width: 899px){
        font-size: 60px;
    }
    @media(max-width: 600px){
        font-size: 45px;
    }
`

export { PageWrapper, CustomButton, SectionHeading }